import { XyoWorldMapStyle } from '../../lib'
import AppSettings from './AppSettings'
import { PlayMapSettings } from './Context'
import AppSettingName from './Name'

class CustomAppSettings extends AppSettings {
  constructor() {
    super('XyoAppSetting')
  }

  get darkMode() {
    return this.getBoolean(AppSettingName.DarkMode)
  }

  set darkMode(value: boolean) {
    this.setBoolean(AppSettingName.DarkMode, value)
  }

  get developerMode() {
    return this.getBoolean(AppSettingName.DeveloperMode)
  }

  set developerMode(value: boolean) {
    this.setBoolean(AppSettingName.DeveloperMode, value)
  }

  get infuraAsDefault() {
    return this.getBoolean(AppSettingName.InfuraAsDefault)
  }

  set infuraAsDefault(value: boolean) {
    this.setBoolean(AppSettingName.InfuraAsDefault, value)
  }

  get mapStyle() {
    return this.getString(AppSettingName.MapStyle) as XyoWorldMapStyle
  }

  set mapStyle(value: XyoWorldMapStyle) {
    this.setString(AppSettingName.MapStyle, value)
  }

  get playMapSettings() {
    return this.getObject<PlayMapSettings>(AppSettingName.PlayMapSettings)
  }

  set playMapSettings(value: PlayMapSettings) {
    this.setObject<PlayMapSettings>(AppSettingName.PlayMapSettings, value)
  }

  get requestLocation() {
    return this.getBoolean(AppSettingName.RequestLocation)
  }

  set requestLocation(value: boolean) {
    this.setBoolean(AppSettingName.RequestLocation, value)
  }
}

export default CustomAppSettings
